import React from "react";
import { API } from "@/lib/api";

export const resolveFileUrl = (u) =>
  u && u.startsWith("/api/") ? `${API.replace(/\/api$/, "")}${u}` : u;

const SIZES = {
  xs: "h-6 w-6 text-[10px]",
  sm: "h-7 w-7 text-xs",
  md: "h-9 w-9 text-sm",
  lg: "h-16 w-16 text-lg",
  xl: "h-24 w-24 text-2xl",
};

export function Avatar({ name, email, src, size = "sm", className = "", ...rest }) {
  const cls = `${SIZES[size] || SIZES.sm} rounded-full shrink-0 ${className}`;
  if (src) {
    return (
      <img
        src={resolveFileUrl(src)}
        alt={name || email || "avatar"}
        className={`${cls} object-cover`}
        {...rest}
      />
    );
  }
  const initials = ((name || email || "?").split(/[ @]/)[0] || "?").slice(0, 2).toUpperCase();
  return (
    <span
      className={`${cls} bg-gray-900 text-amber-300 font-bold inline-flex items-center justify-center`}
      {...rest}
    >
      {initials}
    </span>
  );
}
